interface CheckHoursPassedParams {
  date: Date | null | undefined;
  hours: number;
}

export const checkHoursPassed = ({
  date,
  hours,
}: CheckHoursPassedParams): boolean => {
  if (!date) return false;
  const now = new Date();
  const timeDifference = now.getTime() - date.getTime();
  const hoursPassed = timeDifference / (1000 * 60 * 60);
  return hoursPassed >= hours;
};
